import { configureStore } from '@reduxjs/toolkit';

import rootReducer from 'app/store/rootReducer';
import emptyIdApi from 'app/store/emptyIdApi';

const isDevelopment = process.env.NODE_ENV === 'development';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(emptyIdApi.middleware);
  },
  devTools: isDevelopment,
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type RootDispatch = typeof store.dispatch;
